import { render, screen } from "@testing-library/react";
import LiningTitle from "./LiningTitle";

test("check rendering title", () => {
  render(<LiningTitle title="New title" level={1} />);
  expect(screen.getByText("New title")).toBeInTheDocument();
});
